import BiomarkerResults from '@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerResults';
import RequestSection from '@/features/requests/components/NewRequest/RequestSection';

type Props = {
	patientId?: string;
};

export default function RequestBiomarkerResults({ patientId }: Props) {
  return (
    <RequestSection title="Biomarker Results">
      {patientId && <BiomarkerResults useCardContainer={false} patientId={patientId} />}
    </RequestSection>
  );
}
